<template>
  <div class="header">
    <div @click="toAdminHome">
      <NuxtImg v-if="showLogo"
               class="ml-4 cursor-pointer"
               @click="toHome"
               format="webp"
               loading="lazy"
               :height="isMobile ? 25 : 30"
               src="/logo/osn-zh-horizon.png"
               alt="logo"/>

      <!--      <img v-if="adminLogo" class="logo" :src="picUrl + adminLogo" alt="">-->
<!--            <h1 v-if="!showLogo" class="max-w-[140px] truncate">{{ adminBrandName }}</h1>-->
    </div>
    <div>
      <ul>
        <li v-if="adminLogo || adminBrandName"
            @click="toAdminHome">
          <img src="@/assets/image/icon/menu/admin_home.svg"
               alt="">
          {{ $t('menu.admin_home') }}
        </li>
        <li v-if="isLogin"
            @click="go('/order')">
          <img src="@/assets/image/icon/menu/list_alt.svg"
               alt="">
          {{ '訂單' }}
        </li>
        <li v-if="isLogin"
            @click="go('/account')">
          <img src="@/assets/image/icon/menu/account_circle.svg"
               alt="">
          {{ '帳號' }}
        </li>
        <li v-if="!isLogin"
            class="login"
            @click="handleLogin">{{ $t('menu.login') }}
        </li>
        <li v-if="!isLogin"
            class="register"
            @click="go('/register')">{{ $t('menu.register') }}
        </li>
        <li v-else
            @click="handleLogout">{{ $t('menu.logout') }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup>

import {computed, ref} from "vue";

import {useUserStore} from "@/stores/user";
import {useSettingStore} from "@/stores/setting";

const router = useRouter()
const route = useRoute();
const settingStore = useSettingStore()
const userStore = useUserStore()
const picUrl = ref(import.meta.env.VITE_APP_BASE_IMG_URL)
const isMobile = computed(() => settingStore.isMobile);
const isLogin = computed(() => userStore.getToken);
const props = defineProps({
  adminID: {
    type: String,
    default: ''
  },
  adminLogo: {
    type: String,
    default: ''
  },
  adminBrandName: {
    type: String,
    default: ''
  }
})
const showLogo = route.path.startsWith('/admin/') && !route.path.startsWith('/admin-space/')

const toAdminHome = () => {
  router.push({path: '/admin/' + props.adminID})
}
const go = (url) => {
  router.push({path: url})
}
const toHome = () => {
  location.href = import.meta.env.VITE_APP_BASE_HOME_URL
}
const handleLogin = () => {
  if (isMobile.value) {
    go('/login')
  } else {
    settingStore.updateLoginDialogVisible(true)
  }
}
const handleLogout = async () => {
  await userStore.logout()
  /*const queryData = {
    account: userStore.getAccount
  }

  try {
    await logout(queryData)
  } catch (error) {
    console.log(error)
  }
  userStore.updateToken('');
  userStore.updateAccount('');
  userStore.updateName('');
  userStore.updatePhone('')
  userStore.updateEmail('')
  userStore.updateAccountType('')*/
}
</script>
<style scoped
       lang="scss">
div.header {
  @apply h-[70px] border-b border-osn-grey-02 flex justify-between items-center;
  img.logo {
    @apply ml-[10px] h-[58px] leading-[58px] cursor-pointer;
  }

  h1 {
    @apply ml-[10px] text-[24px] font-bold cursor-pointer;
  }

  ul {
    @apply flex text-[16px];
    li {
      @apply flex mr-[20px] cursor-pointer items-center;
      img {
        @apply mr-[4px] w-[24px];
      }
    }
  }

  .login {
    @apply flex items-center justify-center text-[14px] text-osn-dark-grey-00 font-bold bg-osn-yellow-00 rounded-[50px] py-[6px] px-[36px];
  }

  .register {
    @apply flex items-center justify-center text-[14px] bg-osn-dark-grey-00 font-bold text-osn-yellow-00 rounded-[50px] py-[6px] px-[36px];
  }
}

</style>

<style scoped
       lang="scss">
div.header {
  @apply h-[70px] border-b border-osn-grey-02 flex justify-between items-center;
  img.logo {
    @apply ml-[10px] h-[58px] leading-[58px] cursor-pointer;
  }

  h1 {
    @apply ml-[10px] text-[24px] font-bold cursor-pointer;
  }

  ul {
    @apply flex text-[16px];
    li {
      @apply flex mr-[20px] cursor-pointer items-center;
      img {
        @apply mr-[4px] w-[24px];
      }
    }
  }

  .login {
    @apply flex items-center justify-center text-[14px] text-osn-dark-grey-00 font-bold bg-osn-yellow-00 rounded-[50px] py-[6px] px-[36px];
  }

  .register {
    @apply flex items-center justify-center text-[14px] bg-osn-dark-grey-00 font-bold text-osn-yellow-00 rounded-[50px] py-[6px] px-[36px];
  }
}

</style>
